import { render, staticRenderFns } from "./productSet.vue?vue&type=template&id=054b6aa5&scoped=true"
import script from "./productSet.vue?vue&type=script&lang=js"
export * from "./productSet.vue?vue&type=script&lang=js"
import style0 from "./productSet.vue?vue&type=style&index=0&id=054b6aa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054b6aa5",
  null
  
)

export default component.exports